import { render, staticRenderFns } from "./QrLahanRusak.vue?vue&type=template&id=b803bcf6"
import script from "./QrLahanRusak.vue?vue&type=script&lang=js"
export * from "./QrLahanRusak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports